var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-text-field-default"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('v-text-field',_vm._g(_vm._b({attrs:{"type":_vm.type,"id":_vm.id,"name":_vm.name,"outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('input', $event.value)}}},'v-text-field',
      _vm.$attrs
      // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
    ,false),
      _vm.$listeners
      // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    ))],1)}
var staticRenderFns = []

export { render, staticRenderFns }